// extracted by mini-css-extract-plugin
export default {"grid":"BonusPage_grid__gNPrS","card_body_title":"BonusPage_card_body_title__+DL2K","overlay":"BonusPage_overlay__IVw32"};